import React from 'react';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
  showIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  showIcon = true,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-xl transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-accent-600 text-white hover:bg-accent-700 shadow-[0_4px_14px_0_rgba(220,38,38,0.39)] hover:shadow-[0_6px_20px_rgba(220,38,38,0.23)] hover:-translate-y-0.5',
    secondary: 'bg-brand-900 text-white hover:bg-brand-800 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-brand-200 text-brand-900 hover:border-brand-900 hover:bg-brand-50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else if (href) {
      window.location.href = href;
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={combinedClasses} onClick={handleClick} {...props} data-id="element-54">
      <span className="relative z-10 flex items-center gap-2" data-id="element-55">
        {children}
        {showIcon && <ChevronRight className={`w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 ${size === 'xl' ? 'w-6 h-6' : ''}`} data-id="element-56" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-57" />}
    </motion.button>;
}